import React, { useMemo } from "react";
import { API_DOMAIN } from "config";

export default function ImagesCarousel2({ images }) {
  const requestVersion = useMemo(() => Date.now(), [images]);
  if (!images?.length) return null;

  // שומר רק את הפריט הראשון
  const firstImage = images[0];

  // קובע כתובת מלאה:
  const src =
    firstImage.image_url.startsWith("blob:")
      ? firstImage.image_url
      : `${API_DOMAIN}/${firstImage.image_url}${String(firstImage.image_url).includes("?") ? "&" : "?"}v=${requestVersion}`;

  return (
    <div className="h-[218px] relative overflow-hidden">
      <img
        src={src}
        className="w-full h-full object-cover"
        alt=""
      />
    </div>
  );
}
